import { Box, Card, Paper, Typography } from "@mui/material";
import React from "react";

interface LegendItemProps {
  label: string;
  color?: string;
  gradient?: string;
}

const LegendItem: React.FC<LegendItemProps> = ({ label, color, gradient }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        mb: 1,
        width: "150px"
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: 24,
          height: 24,
          background: gradient || color,
          flexShrink: 0,
          borderRadius: "var(--rounded-lg, 8px)" 
        }}
      />
      <Typography variant="body2">{label}</Typography>
    </Box>
  );
};

export const Legend: React.FC = () => {
  return (
    <Card sx={{  margin: "0px", p: 2 }}>
      <Typography variant="body1" sx={{ mb: 1 }}>
        <strong>Legend</strong>
      </Typography>
      <LegendItem label="Not Flooded" color="#06D6A0" />
      <LegendItem
        label="Building Flooded"
        gradient="linear-gradient(90deg, #FFD166 0%, #EF476F 100%)"
      />
      <LegendItem
        label="Parcel Flooded"
        gradient="linear-gradient(90deg, #5CDCEB 0%, #178FC2 100%)"
      />
    </Card>
  );
};
